<template>
  <section>
    <div class="transaction-card">
      <h5>On: {{formatDate(transaction.date)}}</h5>
      <hr />
      <div class="item-detail">
        <!-- transaction detail -->
        <TransactionItem
          v-for="sold in transaction.Solds"
          :key="sold.id"
          :sold="sold"
        />
      </div>
      <hr />
      <h4>Total: <span class="price">{{getTotalPrice()}}</span></h4>
    </div>
  </section>
</template>

<script>
import TransactionItem from '@/components/TransactionItem'

export default {
  props: ['transaction'],
  components: {
    TransactionItem
  },
  methods: {
    formatDate (date) {
      const formatDate = new Date(date)
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }
      return formatDate.toLocaleString('en-GB', options)
    },
    currFormat (currency) {
      return 'Rp. ' + currency.toLocaleString()
    },
    getTotalPrice () {
      let total = 0
      this.transaction.Solds.forEach(element => {
        total += (element.quantity * element.price)
      })
      return this.currFormat(total)
    }
  }
}
</script>

<style scoped>
  .transaction-card {
    text-align: left;
    box-shadow: 0 0 5px 1px #1e524b;
    margin: 15px;
    padding: 10px;
    transition: 50ms;
  }
  .transaction-card:hover {
    box-shadow: 0 0 10px 2px #1e524b;
    transition: 100ms;
  }
  .price {
    font-weight: bold;
  }
  .item-detail {
    display: flex;
    flex-wrap: wrap
  }
</style>
